import Typography, { type TypographyProps } from "@mui/joy/Typography"

const SpotlightDialogContent = (props: TypographyProps) => {
  return <Typography level="body-sm" textColor="text.primary" {...props} />
}

export default SpotlightDialogContent
